module.exports = __webpack_public_path__ + "static/media/antigua-and-barbuda.c6627c61.svg";